// MobileTopbar — compact phone topbar used by the mobile public screens.
//
// Counterpart to ProtoTopbar (desktop). Layout is slimmer than desktop:
// 19px Bebas title + 9px mono subtitle + a right slot for the clock chip.
//
// The sidebar drawer is opened from the role-bar's hamburger (rendered
// above this topbar by App.tsx) — MobileTopbar deliberately does NOT
// include its own hamburger because that produced two stacked toggles
// on the same screen. The leading slot is reserved for the optional
// back-arrow rendered when `onBack` is supplied (Team Detail returning
// to the prior view).
//
// `onMenu` is accepted as a prop so older call-sites compile, but is
// no longer used — the role-bar hamburger handles the sidebar.

import type { ReactNode } from 'react';

export function MobileTopbar({
  title, subtitle, onBack, right,
}: {
  title: string;
  subtitle?: string;
  /** No-op kept for backward compat; the role-bar hamburger is canonical. */
  onMenu?: () => void;
  onBack?: () => void;
  right?: ReactNode;
}) {
  return (
    <header className="mw-topbar">
      {onBack && (
        <div className="mw-hamb txt-22" onClick={onBack} title="Back">‹</div>
      )}
      <div className="grow">
        <div className="mw-tb-title">{title}</div>
        {subtitle && <div className="mw-tb-sub">{subtitle}</div>}
      </div>
      {right}
    </header>
  );
}
